import { ServiceSheet } from "/react4xp/parts/service-sheet/service-sheet";

export default (props) => <ServiceSheet {...props} />